<template>
  <div class="page landing" :class="{theme2: $route.query.theme==='theme2'}">
    <section class="content">
    </section>
    <div class="btn-contaienr">
      <nd-button @click="downloadApp" class="btn"></nd-button>
    </div>
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
  </div>
</template>

<script>
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'
import DownloadQuestion from '../components/downloadQuestion.vue'

export default {
  name: 'landignSms',
  components: {
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog,
    DownloadQuestion
  },
 
  mounted () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.landing {
  padding-bottom: 160px;
}
.content {
  height: 1914px;
  background: url(https://static.ndmicro.com/tmd/landing/sms/images/them1.png) no-repeat;
  background-size: 100% 100%;
}
.theme2 .content {
  background: url(https://static.ndmicro.com/tmd/landing/sms/images/them2.png) no-repeat;
  background-size: 100% 100%;
}
.btn-contaienr {
  position: fixed;
  bottom: 0;
  width: 750px;
  height: 160px;
  background: linear-gradient(180deg, #FFF4E6 0%, #FFE5C9 100%);
  display: flex;
  justify-content: center;
  .btn {
    width:678px;
    height:160px;
    background: url(https://static.ndmicro.com/tmd/landing/sms/images/btn.png) no-repeat;
    background-size: 100% 100%;
  }
}
</style>